import { render, staticRenderFns } from "./ColorCart.vue?vue&type=template&id=75d8111e"
import script from "./ColorCart.vue?vue&type=script&lang=js"
export * from "./ColorCart.vue?vue&type=script&lang=js"
import style0 from "./ColorCart.vue?vue&type=style&index=0&id=75d8111e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports